module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0030.jpg?v=9d8be06e";